import { client as create } from "@educabot/fetcher"
import { useAuth } from "@/modules/auth/store/use-auth"

export const odinClient = create(import.meta.env.VITE_ODIN_API_URL)
export const cronosClient = create(import.meta.env.VITE_CRONOS_API_URL)
export const hermesClient = create(import.meta.env.VITE_HERMES_API_URL)

const clients = [odinClient, cronosClient, hermesClient]

interface ClientErrorWithStatusCode {
  statusCode?: number
  message?: string
}

clients.forEach((clientInstance) => {
  clientInstance.instance.interceptors.response.use(
    (response) => response,
    (error: ClientErrorWithStatusCode) => {
      if (error.statusCode === 401) {
        const { logOut } = useAuth.getState()
        logOut()
        if (typeof window !== "undefined") {
          window.location.href = "/login"
        }
      }
      return Promise.reject(error)
    },
  )
})
